import {useEffect, useState} from "react";
import "./ViewCandidateNomination.css";
import Box from "@mui/material/Box";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import MyNominationFilter from './MyNominationFilter';
import TablePagination from "@mui/material/TablePagination";
import { CSVLink } from "react-csv";
import MyNominationSearch from "./MyNominationSearch";
import MyNominationDateFilter from "./MyNominationDateFilter";

const MyNominations = () => { 
 const [page, setPage] = useState(0);
 const nominationList = useSelector((state) => state?.deliveryLeadership.myNominationData); 
 const userEnterpriseID = useSelector((state)=>state?.deliveryLeadership.enterpriseID); 
 
 const [rowsPerPage, setRowsPerPage] = useState(25);

 const [filteredData, setFilteredData] = useState([]);
 const [downloadData, setDownloadData] = useState([]);    

 const handleChangePage = (event, newPage) => {
  setPage(newPage);
 };
 const handleChangeRowsPerPage = (event) => {
  setRowsPerPage(parseInt(event.target.value, 10));
  setPage(0);
 };  
 
  useEffect(() => {        
    setFilteredData(nominationList);
  },[nominationList])
 

  const theme = createTheme({
    typography: {
    fontFamily: "Graphik-Regular",
    },
  });

  const headers = [    
    { label: "Email ID", key: "email" },
    { label: "Course Name", key: "courseName" },    
    { label: "Session Type", key: "sessionType" },
    { label: "Start Date", key: "startDate" },
    { label: "End Date", key: "endDate" },    
    { label: "Status", key: "status" }    
  ];

  const statusDetail = {
    0: `Failed Nomination`,
    1: `Waiting for Batch Allocation`,
    2: `Scheduled`,
    3: `Rejected`,
    4: `Waitlisted`,
    5: `Discarded`,
  }

  useEffect(() => {             
    const modifiedDownloadData = filteredData.map(obj => ({ ...obj, 
      status: statusDetail[obj.status], 
      startDate: `${obj.startDate}`,
      endDate: `${obj.endDate}`
    }));    
    setDownloadData(modifiedDownloadData);
  }, [filteredData]);

 return (
  <ThemeProvider theme={theme}>      
    <Box className="upload_table my_nomination_table_container" style={{marginTop: '40px'}}>
    <div className="download_pagination_section">                                                          
        <div className="table-top-header-left-section">
          <MyNominationDateFilter userEnterpriseID={userEnterpriseID}/>                                              
          {filteredData.length !== 0 && <CSVLink data={downloadData} headers={headers} filename={"my-nominations.csv"} target="_blank" className="download_mynominations">
            Download
          </CSVLink>}
        </div>        
        {filteredData.length !== 0 && <>          
          <TablePagination className="upload_nomination_pagination" component="div" count={filteredData != undefined && filteredData.length != 0 ? filteredData.length : null}
            page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage}
            sx={{ visibility:filteredData != undefined && filteredData.length > 0 ? "visible" : "hidden",}}
          />
        </>
        }
      </div>
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
          <TableHead>
          <TableRow>
            <TableCell align="left">Sl No</TableCell>
            <TableCell align="left" className="Enterprise_id_cell">              
              Enterprise ID
              <MyNominationSearch filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} 
                skillType='enterprise_id' />              
            </TableCell>

            <TableCell align="left">
              Course Name
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='course_name'/>
            </TableCell>            
            <TableCell align="left">
              Session Type              
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='mode'/>
            </TableCell>
            <TableCell align="left">
              Start Date
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='start_date'/>
            </TableCell>                        
            <TableCell align="left">
              End Date              
            </TableCell>            
            <TableCell align="left">
              Status
              <MyNominationFilter filteredData={filteredData} setFilteredData={setFilteredData} nominationList={nominationList} skillType='status'/>
              </TableCell>
          </TableRow>
          </TableHead>
          <TableBody>              
            {filteredData.length !== 0 && 
              (rowsPerPage > 0
                ? filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                : filteredData
               ).map((row, index) => (              
              <TableRow key={index}>
                <TableCell align="left" scope="row">
                {index + 1}.
                </TableCell>
                <TableCell align="left" scope="row">
                {row.email}
                </TableCell>
                <TableCell align="left">{row.courseName}</TableCell>                
                <TableCell align="left">{row.sessionType}</TableCell>
                <TableCell align="left">{row.startDate}</TableCell>                                
                <TableCell align="left">{row.endDate}</TableCell>
                <TableCell align="left">
                {row.status == 1 ? (
                  <div className="status_requested_viewnominationtable">
                  <span>Waiting for Batch Allocation</span>
                  </div>
                ) : row.status == 2 ? (
                  <div className="status_approved_viewnominationtable">
                  <span>Scheduled</span>
                  </div>
                ) : row.status == 3 ? (
                  <div className="status_rejected_viewnominationtable_section">
                  <span className="status_rejected_viewnominationtable">Rejected</span>
                  <span className="reason_span">{row?.reason}</span>
                  </div>
                ) : row.status == 4 ? (
                  <div className="status_scheduled_viewnominationtable">
                  <span>Waitlisted</span>
                  </div>
                ) : row.status == 5 ? (
                  <div className="status_waitlistes_viewnominationtable">
                  <span>Discarded</span>
                  </div>
                ) :
                row.status == 0 ? (
                  <div className="status_waitlistes_viewnominationtable" style={{color:"red"}}>
                  <span>Failed Nomination</span>
                  </div>
                )
                : null} 
                </TableCell>
              </TableRow>
            ))}
            {filteredData.length === 0 && <TableRow><TableCell colSpan={7}>No Nominations Found.</TableCell></TableRow>}
          </TableBody>
        </Table>
      </TableContainer>      
      <TablePagination className="upload_nomination_pagination" component="div" count={filteredData && filteredData.length >0 ? filteredData.length : 0}
        page={page} onPageChange={handleChangePage} rowsPerPage={rowsPerPage} onRowsPerPageChange={handleChangeRowsPerPage}
        sx={{ width: "100% !important",visibility:filteredData != undefined && filteredData.length > 0 ? "visible" : "hidden",}}
      />
    </Box>   
  </ThemeProvider>
 );
};

export default MyNominations;
